import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { ChangePerformanceKitView } from "./performanceKit/ChangePerformanceKitView"

export interface GetPerformanceKitQueryParams {
	"inventory-id": string
}

export const getPerformanceKitRoute: ApiRoute<
	NoPathParams,
	GetPerformanceKitQueryParams,
	NoBody,
	ChangePerformanceKitView
> = {
	buildUrl: () => "/equipment/performance-kit",
	method: "get",
	path: "/equipment/performance-kit",
}
